import {
  Layout,
  MAIN_CONTENT_ID,
  SkipToMainContent,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import qs from "qs";
import { useEffect } from "react";
import { Route, Routes } from "react-router";
import { useNavigate } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";

import { PageNotFoundError } from "../components/PageNotFoundError";
import { AppFooter } from "../components/app-footer";
import { AppHeader } from "../components/app-header";
import { DashboardPage } from "../pages/dashboard/DashboardPage";
import { NotificationsPage } from "../pages/general-settings/NotificationsPage";
import { HelpPrivacyPage } from "../pages/general-settings/help-and-privacy/HelpPrivacyPage";
import { ReferAndEarnPage } from "../pages/general-settings/help-and-privacy/ReferAndEarnPage";
import { PersonalInfoPage } from "../pages/general-settings/personal-info/PersonalInfoPage";
import { PreferencesPage } from "../pages/general-settings/preferences/PreferencesPage";
import { PaymentDetailsPage } from "../pages/general-settings/payment-profiles/PaymentDetailsPage";

export function AppRoutes() {
  const navigate = useNavigate();
  const { caseManagementEnableApplicantPayer, enableConsumerDiscountCodes } =
    useFlags();

  useEffect(() => {
    const queryParams = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    if (typeof queryParams.applicantId === "string") {
      navigate(`/apply/${queryParams.applicantId}`);
    }
  });

  return (
    <>
      <SkipToMainContent />
      <Layout
        layout="applicant/narrow"
        header={<AppHeader />}
        footer={<AppFooter />}
      >
        <div id={MAIN_CONTENT_ID} tabIndex={-1} className={styles.main}>
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route
              path="/settings/personal-info"
              element={<PersonalInfoPage />}
            />
            <Route path="/settings/preferences" element={<PreferencesPage />} />
            <Route
              path="/settings/notifications"
              element={<NotificationsPage />}
            />
            {caseManagementEnableApplicantPayer && (
              <Route
                path="/settings/payment-details/*"
                element={<PaymentDetailsPage />}
              />
            )}
            <Route
              path="/settings/help-and-privacy"
              element={<HelpPrivacyPage />}
            />
            {enableConsumerDiscountCodes && (
              <Route
                path="/settings/refer-and-earn"
                element={<ReferAndEarnPage />}
              />
            )}
            <Route path="*" element={<PageNotFoundError />} />
          </Routes>
        </div>
      </Layout>
    </>
  );
}

const styles = {
  main: css({
    "&:focus": {
      outline: "none",
    },
  }),
};
